<template>
  <section class="faq">
    <div class="container">
      <div class="section-header">
        <span class="tag">{{ t('faq.tag') }}</span>
        <h2 class="serif">{{ t('faq.title') }}</h2>
      </div>

      <div class="faq-list">
        <details v-for="n in 7" :key="n" class="faq-item" data-reveal>
          <summary>{{ t(`faq.q${n}.summary`) }}</summary>
          <div class="answer" v-html="t(`faq.q${n}.answer`)"></div>
        </details>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t } = useLocale()
</script>

<style scoped>
.faq { padding: 100px 0; }
@media (max-width: 768px) { .faq { padding: 48px 0; } }
.section-header { text-align: center; margin-bottom: 64px; }
.section-header .tag {
  display: inline-block;
  background: var(--ink);
  color: var(--bg);
  padding: 6px 16px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin-bottom: 24px;
  border-radius: 999px;
}
.section-header h2 {
  font-size: clamp(40px, 6vw, 72px);
  font-weight: 800;
  line-height: 0.98;
  letter-spacing: -0.03em;
  margin-bottom: 20px;
}
.faq-list { max-width: 800px; margin: 0 auto; }
.faq-item {
  border-top: 1px solid var(--line-soft);
  position: relative;
  isolation: isolate;
}
.faq-item::before {
  content: '';
  position: absolute;
  inset: 8px -20px;
  background: var(--bg-soft);
  border-radius: 16px;
  opacity: 0;
  transition: opacity 0.25s;
  z-index: -1;
}
.faq-item:hover::before,
.faq-item[open]::before {
  opacity: 1;
}
.faq-item:last-child { border-bottom: 1px solid var(--line-soft); }
.faq-item summary {
  padding: 28px 0;
  cursor: pointer;
  font-family: 'Fraunces', serif;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.025em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  list-style: none;
}
.faq-item summary::-webkit-details-marker { display: none; }
.faq-item summary::after {
  content: '+';
  font-family: 'Inter', sans-serif;
  font-size: 32px;
  font-weight: 300;
  color: var(--blue);
  transition: transform 0.2s;
  flex-shrink: 0;
}
.faq-item[open] summary::after { transform: rotate(45deg); }
.faq-item .answer {
  padding: 0 0 32px 0;
  font-size: 16px;
  color: var(--ink-soft);
  line-height: 1.65;
  max-width: 64ch;
}
.faq-item .answer :deep(a) {
  color: var(--ink);
  text-decoration: underline;
  text-decoration-color: var(--blue);
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
}
</style>
